/* global angular */
function lightboxModalController() {
    this.closeLightboxModal = function () {
        $('body').removeClass('lightboxed');
        $('.lightbox-modal__backdrop').remove();
        $('.lightbox-modal').hide();
    };

    const closeLightboxModal = this.closeLightboxModal;

    function handleModalSubmit(lightbox, mode = 'default') {
        const isNone = mode === 'none';
        const modalAttr = isNone ? 'lightbox-modal-none' : 'lightbox-modal';
        const successTargetAttr = isNone
            ? 'lightbox-modal-success-target-none'
            : 'lightbox-modal-success-target';
        const emptyFormSelector = isNone ? '#empty-form-none' : '#empty-form';
        const targetModal = $(lightbox).data(modalAttr);

        let successTarget = $(lightbox).closest(`.${$(lightbox).data(successTargetAttr)}`);
        if ($(emptyFormSelector).length) {
            successTarget = $(emptyFormSelector);
        }

        $(`.${targetModal}`)
            .show()
            .find('.js-lightbox-modal-submit')
            .one('click', function () {
                // Populate hidden fields if needed
                const alertId = $(lightbox).data('alertid');
                const title = $(lightbox).data('title');
                const index = $(lightbox).data('index');

                if (alertId != null && title != null && index != null && $(emptyFormSelector).length) {
                    $(`${emptyFormSelector} input[name="Id"]`).val(alertId);
                    $(`${emptyFormSelector} input[name="Title"]`).val(title);
                    $(`${emptyFormSelector} input[name="rowId"]`).val(index);
                }

                // Check if it's a "form-free" version
                const isFormless = !successTarget.is('form');

                if (isFormless) {
                    // Handle custom form-free AJAX submit
                    const postData = {
                        DocumentID: successTarget.data('document-id'),
                        SalesforceID: successTarget.data('salesforce-id'),
                        Title: successTarget.data('analytics-title'),
                        Publication: successTarget.data('analytics-publication'),
                    };

                    $.ajax({
                        url: '/Account/api/SavedDocumentApi/RemoveItem/',
                        method: 'POST',
                        contentType: 'application/json',
                        data: JSON.stringify(postData),
                        success: function (res) {
                            console.log("Form-free AJAX success", res);
                            // Optionally refresh list or show message
                        },
                        error: function (err) {
                            console.error("Form-free AJAX error", err);
                        },
                        complete: function () {
                            closeLightboxModal();
                        }
                    });
                } else {
                    // Submit the actual form
                    successTarget.find('button[type=submit]').click();
                    closeLightboxModal();
                    if($("body").hasClass('theme-wards')){
                        setTimeout(function(){
                            window.location.reload(true);
                        }, 1000);
                    }
                }
            });

        $('body').addClass('lightboxed').append('<div class="lightbox-modal__backdrop"></div>');
    }

    this.showLightbox = function (lightbox) {
        handleModalSubmit(lightbox, 'default');
        return false;
    };

    this.showLightboxnone = function (lightbox) {
        handleModalSubmit(lightbox, 'none');
        return false;
    };

    const showLightbox = this.showLightbox;
    const showLightboxnone = this.showLightboxnone;

    this.buildLightboxes = function () {
        $(document).on('click', '.js-lightbox-modal-trigger', function (e) {
            if (e.target !== this) {
                this.click();
                return;
            }
            showLightbox(e.target);
            return false;
        });

        $(document).on('click', '.js-lightbox-modal-trigger-none', function (e) {
            if (e.target !== this) {
                this.click();
                return;
            }
            showLightboxnone(e.target);
            return false;
        });
    };

    this.clearLightboxes = function () {
        $('.js-lightbox-modal-trigger, .js-lightbox-modal-trigger-none').off();
    };

    $('.js-close-lightbox-modal').on('click', function () {
        closeLightboxModal();
    });

    this.buildLightboxes();
}

export default lightboxModalController;